import { Controller } from "@hotwired/stimulus"

// Lädt Outlook-Kalendertermine per AJAX und ersetzt die Skeleton-Anzeige.
// URL und loading-Flag kommen aus data-outlook-calendar-url-value / data-outlook-calendar-loading-value.
export default class extends Controller {
  static values = {
    url: String,
    loading: Boolean,
    viewType: { type: String, default: "month" }
  }

  static targets = ["day", "error"]

  connect() {
    if (!this.loadingValue || !this.urlValue) return
    this.load()
  }

  async load() {
    try {
      const res = await fetch(this.urlValue, {
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      })
      const data = await res.json()

      if (data.error) {
        this.showError(data.message || "Outlook-Kalender konnte nicht geladen werden.")
        this.clearSkeletons()
        return
      }

      this.hideError()
      const eventsByDate = data.events_by_date || {}
      const badge = data.outlook_badge || "Outlook"
      const isWeek = this.viewTypeValue === "week"

      this.dayTargets.forEach(cell => {
        const dateKey = cell.dataset.date
        const events = eventsByDate[dateKey] || []
        cell.innerHTML = events.map(ev => this.cardHtml(ev, badge, isWeek)).join("")
      })
    } catch (e) {
      this.showError("Outlook-Kalender konnte nicht geladen werden.")
      this.clearSkeletons()
    }
  }

  cardHtml(ev, badge, isWeek) {
    const size = isWeek ? "text-sm p-3 mb-2" : "text-xs p-2 mb-1"
    const subject = this.escapeHtml(ev.subject || "—")
    const link = ev.web_link
    const subjectHtml = link
      ? `<a href="${this.escapeAttr(link)}" target="_blank" rel="noopener" class="hover:underline block truncate font-medium text-slate-900">${subject}</a>`
      : `<span class="block truncate font-medium">${subject}</span>`
    const timeLabel = ev.start_time_label ? `<div class="text-xs text-slate-600 mt-1">${this.escapeHtml(ev.start_time_label)}</div>` : ""
    const badgeCls = isWeek ? "text-xs text-slate-500 mt-1" : "text-xs text-slate-500 mt-0.5"
    const badgeHtml = `<div class="${badgeCls}">${this.escapeHtml(badge)}</div>`
    return `<div class="${size} rounded truncate border border-slate-400 bg-slate-100 text-slate-900">${subjectHtml}${timeLabel}${badgeHtml}</div>`
  }

  escapeHtml(s) {
    const div = document.createElement("div")
    div.textContent = s
    return div.innerHTML
  }

  escapeAttr(s) {
    return s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.classList.add("hidden")
    this.errorTarget.textContent = ""
  }

  clearSkeletons() {
    this.dayTargets.forEach(cell => {
      const skeleton = cell.querySelector(".outlook-skeleton")
      if (skeleton) skeleton.remove()
    })
  }
}
